// 2022 Topps Star Wars Signature Series — the second all-autograph Signature
// Series product (released February 16, 2022; 1 encased autograph per box,
// 1 card per pack, 20 boxes per case).
// Cards verified against the official Topps checklist (the GTS Distribution
// copy, 2022-Topps-Star-Wars-Signature-Series-Trading-Cards-Checklist.xls);
// structure and parallels cross-checked against Beckett and Cardboard
// Connection, which agree on every count and print run.
// The official checklist splits the A-design autographs into two blocks —
// AUTOGRAPH CARDS A I (85) and A II (61, together the 146 "Autographs" that
// Beckett/CC list merged) — plus AUTOGRAPH CARDS B (56), the design variants
// on a 1980 Topps Empire Strikes Back-inspired design. Card order inside each
// block is Topps' own (star-power, not alphabetical) — kept verbatim.
// Base autographs are unnumbered encased cards with a five-tier
// Blue /50 -> Green /25 -> Orange /10 -> Black /5 -> Red 1/1 ladder — unlike
// 2021, there is NO Purple /99 tier this year.
// Duals and triples have only the Red 1/1 parallel; their base cards' serial
// status is unpublished (no source gives a run) — modeled with no serial slot,
// matching 2021-signature-series. Quad autographs (new for 2022) ARE the
// one-of-ones — shown via the unnamed /1 slot, the 2023 quad precedent.
// The official checklist publishes NO character pairings for 2022 (unlike the
// 2021/2023 PDFs) and neither do Beckett/CC/Cardsmiths — TCDB has only partial
// crowdsourced coverage — so cards carry the signer only, no artist field.
// Signer-name whitespace artifacts in the xls ("Cas  Anvar", trailing spaces)
// collapsed; spellings otherwise verbatim.

export const SETS = [
  {
    id: "autograph-cards-a-i", type: "auto", title: "AUTOGRAPH CARDS A I — 85 CARDS",
    parallels: [
      {id:"blue",name:"Blue",print_run:50,color:"#4d9fff"},
      {id:"green",name:"Green",print_run:25,color:"#00e676"},
      {id:"orange",name:"Orange",print_run:10,color:"#ff9100"},
      {id:"black",name:"Black",print_run:5,color:"#a8a8b4"},
      {id:"red",name:"Red",print_run:1,color:"#ff5d5d"},
    ],
    cards: [
      {n:"A-HF", name:"Harrison Ford"},
      {n:"A-EC", name:"Emilia Clarke"},
      {n:"A-DG", name:"Domhnall Gleeson"},
      {n:"A-AD", name:"Adam Driver"},
      {n:"A-HC", name:"Hayden Christensen"},
      {n:"A-FJ", name:"Felicity Jones"},
      {n:"A-SG", name:"Sarah Michelle Gellar"},
      {n:"A-AH", name:"Alden Ehrenreich"},
      {n:"A-WH", name:"Werner Herzog"},
      {n:"A-KB", name:"Kenny Baker"},
      {n:"A-LD", name:"Laura Dern"},
      {n:"A-TC", name:"Tim Curry"},
      {n:"A-PB", name:"Paul Bettany"},
      {n:"A-WD", name:"Warwick Davis"},
      {n:"A-RA", name:"Riz Ahmed"},
      {n:"A-TB", name:"Tom Baker"},
      {n:"A-BB", name:"Ben Burtt"},
      {n:"A-AB", name:"Ahmed Best"},
      {n:"A-JB", name:"John Boyega"},
      {n:"A-NA", name:"Naomi Ackie"},
      {n:"A-MC", name:"Michael Carter"},
      {n:"A-KCH", name:"Keisha Castle-Hughes"},
      {n:"A-GE", name:"Giancarlo Esposito"},
      {n:"A-GG", name:"Greg Grunberg"},
      {n:"A-JI", name:"Jason Isaacs"},
      {n:"A-AE", name:"Ashley Eckstein"},
      {n:"A-AB2", name:"Anna Brewster"},
      {n:"A-JB2", name:"Jeremy Bulloch"},
      {n:"A-AD1", name:"Annabelle Davis"},
      {n:"A-MD", name:"Mark Dodson"},
      {n:"A-KF", name:"Kate Fleetwood"},
      {n:"A-NF", name:"Nika Futterman"},
      {n:"A-JG", name:"Janina Gavankar"},
      {n:"A-AH1", name:"Amanda Hale"},
      {n:"A-BH", name:"Brian Herring"},
      {n:"A-CH", name:"Clint Howard"},
      {n:"A-SL", name:"Scott Lawrence"},
      {n:"A-SM", name:"Suzie McGrath"},
      {n:"A-CS", name:"Christopher Sean"},
      {n:"A-PB2", name:"Paul Blake"},
      {n:"A-AB1", name:"Ariyon Bakare"},
      {n:"A-HC1", name:"Hermione Corfield"},
      {n:"A-NF1", name:"Nina Fallon"},
      {n:"A-GH", name:"Garrick Hagon"},
      {n:"A-PK", name:"Paul Kasey"},
      {n:"A-SB", name:"Steven Blum"},
      {n:"A-RB", name:"Ralph Brown"},
      {n:"A-TG", name:"Taylor Gray"},
      {n:"A-OA", name:"Omid Abtahi"},
      {n:"A-HD", name:"Harley Durst"},
      {n:"A-ME", name:"Mike Edmonds"},
      {n:"A-MJ", name:"Michael Jibson"},
      {n:"A-DB", name:"Dee Bradley Baker"},
      {n:"A-MB", name:"Mark Boone Jr."},
      {n:"A-RB1", name:"Richard Brake"},
      {n:"A-DC", name:"Dave Chapman"},
      {n:"A-BD", name:"Ben Daniels"},
      {n:"A-TD", name:"Tim Dry"},
      {n:"A-DI", name:"Diana Lee Inosanto"},
      {n:"A-ZJ", name:"Zac Jensen"},
      {n:"A-PA", name:"Philip Alexander"},
      {n:"A-CA", name:"Cas Anvar"},
      {n:"A-MA", name:"Mark Austin"},
      {n:"A-CB", name:"Chris Bartlett"},
      {n:"A-DB1", name:"Dmitrious Bistrevsky"},
      {n:"A-PB1", name:"Paul Brooke"},
      {n:"A-SC", name:"Scott Capurro"},
      {n:"A-LC", name:"Lily Cole"},
      {n:"A-MC1", name:"Michaela Cottrell"},
      {n:"A-SC1", name:"Sean Crawford"},
      {n:"A-NC", name:"Nathalie Cuzner"},
      {n:"A-RA1", name:"Robin Atkin Downes"},
      {n:"A-RA2", name:"Robin Atkin Downes"},
      {n:"A-EE", name:"Emun Elliott"},
      {n:"A-AF", name:"Anna Francolini"},
      {n:"A-AG", name:"Anna Graves"},
      {n:"A-GH1", name:"Gerald Home"},
      {n:"A-SK", name:"Simon Kassianides"},
      {n:"A-MB1", name:"Michonne Bourriague"},
      {n:"A-OD", name:"Oliver Ford Davies"},
      {n:"A-VK", name:"Valene Kane"},
      {n:"A-BB1", name:"Blair Bess"},
      {n:"A-CE", name:"Chris Edgerly"},
      {n:"A-NK1", name:"Nick Kellington"},
      {n:"A-NK2", name:"Nick Kellington"},
    ]
  },
  {
    id: "autograph-cards-a-ii", type: "auto", title: "AUTOGRAPH CARDS A II — 61 CARDS",
    parallels: [
      {id:"blue",name:"Blue",print_run:50,color:"#4d9fff"},
      {id:"green",name:"Green",print_run:25,color:"#00e676"},
      {id:"orange",name:"Orange",print_run:10,color:"#ff9100"},
      {id:"black",name:"Black",print_run:5,color:"#a8a8b4"},
      {id:"red",name:"Red",print_run:1,color:"#ff5d5d"},
    ],
    cards: [
      {n:"A-EM", name:"Ewan McGregor"},
      {n:"A-GC", name:"Gwendoline Christie"},
      {n:"A-BW", name:"Billy Dee Williams"},
      {n:"A-FW", name:"Forest Whitaker"},
      {n:"A-CW", name:"Carl Weathers"},
      {n:"A-KMT", name:"Kelly Marie Tran"},
      {n:"A-JL", name:"John Leguizamo"},
      {n:"A-BL", name:"Billie Lourd"},
      {n:"A-NN", name:"Nick Nolte"},
      {n:"A-AS", name:"Andy Serkis"},
      {n:"A-TW", name:"Taika Waititi"},
      {n:"A-MM1", name:"Mads Mikkelsen"},
      {n:"A-DM", name:"Dominic Monaghan"},
      {n:"A-RP", name:"Ray Park"},
      {n:"A-RP1", name:"Ron Perlman"},
      {n:"A-FPJ", name:"Freddie Prinze Jr."},
      {n:"A-DY", name:"Donnie Yen"},
      {n:"A-SW", name:"Sam Witwer"},
      {n:"A-PR", name:"Paul Reubens"},
      {n:"A-GT", name:"George Takei"},
      {n:"A-MK", name:"Mercedes Varnado"},
      {n:"A-AT", name:"Alan Tudyk"},
      {n:"A-DL", name:"Denis Lawson"},
      {n:"A-SS1", name:"Sema-Tawi Smart"},
      {n:"A-TM", name:"Temuera Morrison"},
      {n:"A-PM", name:"Peter Mayhew"},
      {n:"A-ML", name:"Matt Lanter"},
      {n:"A-DT", name:"David Tennant"},
      {n:"A-AE2", name:"Ashley Eckstein"},
      {n:"A-KL", name:"Ken Leung"},
      {n:"A-LM", name:"Lewis MacLeod"},
      {n:"A-VM", name:"Vanessa Marshall"},
      {n:"A-KM", name:"Cathy Munroe"},
      {n:"A-ES", name:"Emily Swallow"},
      {n:"A-DT1", name:"Dee Tails"},
      {n:"A-MW", name:"Matthew Wood"},
      {n:"A-AW", name:"Andrew Woodall"},
      {n:"A-LM1", name:"Lars Mikkelsen"},
      {n:"A-AR", name:"Alan Ruscoe"},
      {n:"A-OS", name:"Orli Shoshan"},
      {n:"A-LW", name:"Leeanna Walsman"},
      {n:"A-AK", name:"Andrew Kishino"},
      {n:"A-RO", name:"Rena Owen"},
      {n:"A-MP", name:"Michael Pennington"},
      {n:"A-CR", name:"Clive Revill"},
      {n:"A-LT", name:"Lee Towersey"},
      {n:"A-DB2", name:"Dee Bradley Baker"},
      {n:"A-AG1", name:"Anna Graves"},
      {n:"A-JK", name:"Jack Klaff"},
      {n:"A-HQ", name:"Hugh Quarshie"},
      {n:"A-CO", name:"Candice Orwell"},
      {n:"A-SS", name:"Stephanie Silva"},
      {n:"A-BS", name:"Bruce Spence"},
      {n:"A-OW", name:"Oliver Walpole"},
      {n:"A-PL", name:"Paul Sun-Hyung Lee"},
      {n:"A-KO", name:"Katy O'Brian"},
      {n:"A-LS", name:"Leilani Shiu"},
      {n:"A-AW1", name:"Alexander Wraith"},
      {n:"A-IR", name:"Ian Ruskin"},
      {n:"A-KS1", name:"Kath Soucie"},
      {n:"A-BM1", name:"Ben Mendelsohn"},
    ]
  },
  {
    id: "autograph-cards-b", type: "auto", title: "AUTOGRAPH CARDS B (ESB DESIGN VARIANTS) — 56 CARDS",
    parallels: [
      {id:"blue",name:"Blue",print_run:50,color:"#4d9fff"},
      {id:"green",name:"Green",print_run:25,color:"#00e676"},
      {id:"orange",name:"Orange",print_run:10,color:"#ff9100"},
      {id:"black",name:"Black",print_run:5,color:"#a8a8b4"},
      {id:"red",name:"Red",print_run:1,color:"#ff5d5d"},
    ],
    cards: [
      {n:"AV-HF", name:"Harrison Ford"},
      {n:"AV-EM", name:"Ewan McGregor"},
      {n:"AV-EC", name:"Emilia Clarke"},
      {n:"AV-DG", name:"Domhnall Gleeson"},
      {n:"AV-AD", name:"Adam Driver"},
      {n:"AV-HC", name:"Hayden Christensen"},
      {n:"AV-FJ", name:"Felicity Jones"},
      {n:"AV-FW", name:"Forest Whitaker"},
      {n:"AV-SG", name:"Sarah Michelle Gellar"},
      {n:"AV-AE", name:"Alden Ehrenreich"},
      {n:"AV-GC", name:"Gwendoline Christie"},
      {n:"AV-BW", name:"Billy Dee Williams"},
      {n:"AV-WH", name:"Werner Herzog"},
      {n:"AV-IM", name:"Ian McDiarmid"},
      {n:"AV-KB", name:"Kenny Baker"},
      {n:"AV-CW", name:"Carl Weathers"},
      {n:"AV-LD", name:"Laura Dern"},
      {n:"AV-NN", name:"Nick Nolte"},
      {n:"AV-AS", name:"Andy Serkis"},
      {n:"AV-TW", name:"Taika Waititi"},
      {n:"AV-PB", name:"Paul Bettany"},
      {n:"AV-WD", name:"Warwick Davis"},
      {n:"AV-RP", name:"Ray Park"},
      {n:"AV-FPJ", name:"Freddie Prinze Jr."},
      {n:"AV-DY", name:"Donnie Yen"},
      {n:"AV-MK", name:"Mercedes Varnado"},
      {n:"AV-AT", name:"Alan Tudyk"},
      {n:"AV-JB", name:"John Boyega"},
      {n:"AV-TM", name:"Temuera Morrison"},
      {n:"AV-MC", name:"Michael Carter"},
      {n:"AV-KC", name:"Keisha Castle-Hughes"},
      {n:"AV-GE", name:"Giancarlo Esposito"},
      {n:"AV-GG", name:"Greg Grunberg"},
      {n:"AV-ML", name:"Matt Lanter"},
      {n:"AV-AE1", name:"Ashley Eckstein"},
      {n:"AV-AE2", name:"Ashley Eckstein"},
      {n:"AV-JB1", name:"Jeremy Bulloch"},
      {n:"AV-AD1", name:"Annabelle Davis"},
      {n:"AV-NF", name:"Nika Futterman"},
      {n:"AV-JG", name:"Janina Gavankar"},
      {n:"AV-MW", name:"Matthew Wood"},
      {n:"AV-PB1", name:"Paul Blake"},
      {n:"AV-CR", name:"Clive Revill"},
      {n:"AV-SB", name:"Steve Blum"},
      {n:"AV-TG", name:"Taylor Gray"},
      {n:"AV-OA", name:"Omid Abtahi"},
      {n:"AV-DB", name:"Dee Bradley Baker"},
      {n:"AV-MB", name:"Mark Boone Jr."},
      {n:"AV-DC", name:"Dave Chapman"},
      {n:"AV-RB", name:"Richard Brake"},
      {n:"AV-PA", name:"Philip Alexander"},
      {n:"AV-CB", name:"Chris Bartlett"},
      {n:"AV-DB1", name:"Dmitrious Bistrevsky"},
      {n:"AV-RA", name:"Robin Atkin Downes"},
      {n:"AV-SK", name:"Simon Kassianides"},
      {n:"AV-NK", name:"Nick Kellington"},
    ]
  },
  {
    id: "dual-autographs", type: "auto", title: "DUAL AUTOGRAPHS — 3 CARDS",
    parallels: [
      {id:"red",name:"Red",print_run:1,color:"#ff5d5d"},
    ],
    cards: [
      {n:"DA-MWT", name:"Ray Park / Matthew Wood"},
      {n:"DA-FJD", name:"Felicity Jones / Donnie Yen"},
      {n:"DA-JTA", name:"James Arnold Taylor / Anna Graves"},
    ]
  },
  {
    id: "triple-autographs", type: "auto", title: "TRIPLE AUTOGRAPHS — 3 CARDS",
    parallels: [
      {id:"red",name:"Red",print_run:1,color:"#ff5d5d"},
    ],
    cards: [
      {n:"TA-LJ", name:"Daisy Ridley / John Boyega / Laura Dern"},
      {n:"TA-RO", name:"Felicity Jones / Alan Tudyk / Riz Ahmed"},
      {n:"TA-FAW", name:"Adam Driver / Domhnall Gleeson / Andy Serkis"},
    ]
  },
  {
    id: "quad-autographs", type: "auto", title: "QUAD AUTOGRAPHS — 3 CARDS",
    parallels: [
      {id:"base",name:"",print_run:1,color:"#c8d8f0"},
    ],
    cards: [
      {n:"QA-CW", name:"Ashley Eckstein / James Arnold Taylor / Matt Lanter / Dee Bradley Baker"},
      {n:"QA-FA", name:"Harrison Ford / Carrie Fisher / Daisy Ridley / Adam Driver"},
      {n:"QA-SA", name:"Ian McDiarmid / Ray Park / Hayden Christensen / Adam Driver"},
    ]
  },
];
